<script>
    import { redirect } from "@roxi/routify";

    import { createEventDispatcher } from "svelte";

    import InviteNewUsersPlaceholder from "$/components/InviteNewUsersPlaceholder.svelte";

    import { GiftStore, PricingPlan } from "$/stores/GiftStore";

    import Panel from "../_components/Panel.svelte";
    import PanelHeader from "../_components/PanelHeader.svelte";
    import InviteUserInput from "./_components/InviteUserInput.svelte";
    import SentGift from "./_components/SentGift.svelte";

    const dispatch = createEventDispatcher();

    function handleUpgrade() {
        $redirect("/payment");
        dispatch("close");
    }

    $: numberOfAvaliableGifts =
        GiftStore.getProGifts($GiftStore).length -
        GiftStore.getSentProGifts($GiftStore).length;
</script>

<Panel>
    <PanelHeader title="Invitations" on:close={() => dispatch("close")} />

    <div class="invitations-content">
        <div class="gifts">
            <h2 class="invitation-header">
                Invite friends to join Collabwriting
            </h2>

            <div class="gift-list">
                {#each GiftStore.getFreeGifts($GiftStore) as gift}
                    <SentGift {gift} />
                {/each}
                <InviteUserInput pricingPlan={PricingPlan.FREE} />
            </div>
        </div>

        <div class="gifts">
            <h2 class="invitation-header">Gift a Collabwriting PRO</h2>

            <div class="gift-list">
                {#if GiftStore.getProGifts($GiftStore).length > 0}
                    {#if numberOfAvaliableGifts > 0}
                        <span class="message">
                            You have {numberOfAvaliableGifts === 1
                                ? "1 gift"
                                : numberOfAvaliableGifts + " gifts"} left
                        </span>
                    {/if}

                    {#each GiftStore.getSentProGifts($GiftStore) as gift}
                        <SentGift {gift} />
                    {/each}

                    {#if GiftStore.getProGifts($GiftStore).length > GiftStore.getSentProGifts($GiftStore).length}
                        <InviteUserInput pricingPlan={PricingPlan.PRO} />
                    {/if}
                {:else if $GiftStore === null}
                    <InviteUserInput loading={true} />
                {:else}
                    <InviteNewUsersPlaceholder
                        ctaClick={handleUpgrade}
                        planName="Tier 2"
                    />
                {/if}
            </div>
        </div>
    </div>
</Panel>

<style>
    @import "../../../main.css";

    .invitations {
        @apply flex h-full w-full flex-col overflow-auto bg-gray-100 !important;
    }

    .invitations-content {
        @apply reset flex flex-1 flex-col gap-8 overflow-auto px-4 py-4 !important;
    }

    .invitation-header {
        @apply reset mb-2 !important;
    }

    .message {
        @apply rounded-sm bg-yellow-200 px-4 py-2 text-xs text-yellow-600 shadow-sm !important;
    }

    .gifts {
        @apply flex flex-col !important;
    }

    .gift-list {
        @apply flex flex-col gap-2 !important;
    }
</style>
